module.exports = __webpack_public_path__ + "static/media/June 11, 2024 Receivership Order.5e7feb13.pdf";